// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.va3YK3ODp0hiUaDWlnOM {
  overflow-y: auto;
  height: calc(100vh - 4.813rem - 5.688rem);
  padding: 0 var(--spacer-6) var(--spacer-5) var(--spacer-6);
}

.rT0GjRkQuWZIrL3ixdyU {
  width: -moz-fit-content;
  width: fit-content;
}

.BlJuGP1MMffI70uJZuQu {
  font-weight: var(--font-weight-light);
  color: var(--gray-900);
  font-size: var(--text-5);
  line-height: 120%;
  margin-bottom: var(--spacer-7);
}

.CL0k6imIMv_WHXRtwieA {
  font-size: 1.125rem;
  line-height: 120%;
  font-weight: 800;
  color: var(--gray-900);
  margin-bottom: var(--spacer-1);
}

.NAYJKItNTaqunfi0hBtj {
  font-size: 0.875rem;
  color: var(--gray-500);
}

.fCBQvN1goPFM_yl26dEO {
  font-size: var(--text-1);
  color: var(--gray-500);
  margin-top: var(--spacer-2);
}

.GO0jidtWloQ8qNPogqw_ {
  width: 100%;
  position: absolute;
  border-top: var(--component-border-width) solid var(--component-border-color) !important;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: var(--spacer-4);
  padding: var(--spacer-5);
}`, "",{"version":3,"sources":["webpack://./src/modules/settings/components/generalConfigPage/generalConfigPage.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,0DAA0D;AAC5D;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wFAAwF;EACxF,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;AAC1B","sourcesContent":[".container {\n  overflow-y: auto;\n  height: calc(100vh - 4.813rem - 5.688rem);\n  padding: 0 var(--spacer-6) var(--spacer-5) var(--spacer-6);\n}\n\n.refetchButton {\n  width: fit-content;\n}\n\n.title {\n  font-weight: var(--font-weight-light);\n  color: var(--gray-900);\n  font-size: var(--text-5);\n  line-height: 120%;\n  margin-bottom: var(--spacer-7);\n}\n\n.subtitle {\n  font-size: 1.125rem;\n  line-height: 120%;\n  font-weight: 800;\n  color: var(--gray-900);\n  margin-bottom: var(--spacer-1);\n}\n\n.description {\n  font-size: 0.875rem;\n  color: var(--gray-500);\n}\n\n.hint {\n  font-size: var(--text-1);\n  color: var(--gray-500);\n  margin-top: var(--spacer-2);\n}\n\n.footer {\n  width: 100%;\n  position: absolute;\n  border-top: var(--component-border-width) solid var(--component-border-color) !important;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--spacer-4);\n  padding: var(--spacer-5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `va3YK3ODp0hiUaDWlnOM`,
	"refetchButton": `rT0GjRkQuWZIrL3ixdyU`,
	"title": `BlJuGP1MMffI70uJZuQu`,
	"subtitle": `CL0k6imIMv_WHXRtwieA`,
	"description": `NAYJKItNTaqunfi0hBtj`,
	"hint": `fCBQvN1goPFM_yl26dEO`,
	"footer": `GO0jidtWloQ8qNPogqw_`
};
export default ___CSS_LOADER_EXPORT___;
